import "bootstrap-icons/font/bootstrap-icons.css";
import ReactDOM from "react-dom/client";
import ReactPWAInstallProvider from "react-pwa-install";
import { Provider } from "react-redux";
import { ToastContainer } from "react-toastify";
import App from "./App";
import { store } from "./store";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <ReactPWAInstallProvider>
      <App />
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </ReactPWAInstallProvider>
  </Provider>,
);
